import React from 'react';

import OrgSettingLayout from '@views/Organization/OrgSettingManagementLayout';
import LicensePlan from '@views/Organization/Setting/LicensePlan/LicensePlan';

export default function LicePlanManagementPage(
  props: PagePropsWithBreadcrumbs
) {
  return (
    <OrgSettingLayout pageProps={props}>
      {({ account_id: acct_id }) => <LicensePlan account_id={acct_id} />}
    </OrgSettingLayout>
  );
}
